module.exports = __webpack_public_path__ + "img/pexels-philip-boakye-1813947.37eefc22.jpg";